import fetchClient from './index';
import {BASE_URL, endPoints} from './urls';

export const almPostId = async (value: any) => {
  try {
    const response = await fetchClient().post(`${BASE_URL}${endPoints.ADD_ALM_POST_ID}`, value);
    return response;
  } catch (e) {
    console.log('error', e);
    return e;
  }
};

export const almCommentId = async (value: any) => {
  try {
    const response = await fetchClient().post(`${BASE_URL}${endPoints.ADD_ALM_COMMENTS_ID}`, value);
    return response;
  } catch (e) {
    console.log('error', e);
    return e;
  }
};

export const almNotesReply = async (value: any) => {
  try {
    const response = await fetchClient().post(`${BASE_URL}${endPoints.ALM_NOTES_REPLY}`, value);
    return response;
  } catch (e) {
    console.log('error', e);
    return e;
  }
};

export const getAlmNotes = async () => {
  try {
    const response = await fetchClient().post(`${BASE_URL}${endPoints.GET_ALM_NOTES_COMMENTS}`);
    return response;
  } catch (e) {
    console.log('error', e);
    return e;
  }
};

export const AlmNotesMApping = async () => {
  try {
    const response = await fetchClient().get(`${BASE_URL}${endPoints.ALM_NOTES_MAPPING}`);
    return response;
  } catch (e) {
    console.log('error', e);
    return e;
  }
};

export const sequenceForNotes = async (payload: any) => {
  try {
    const response = await fetchClient().post(
      `${BASE_URL}${endPoints.ALM_NOTES_SEQUENCE}`,
      payload
    );
    return response;
  } catch (e) {
    console.log('error', e);
    return e;
  }
};

export const updateSequenceForNotes = async (id: any) => {
  try {
    const response = await fetchClient().post(
      `${BASE_URL}${endPoints.ALM_UPDATE_NOTES_SEQUENCE(id)}`
    );
    return response;
  } catch (e) {
    console.log('error', e);
    return e;
  }
};
export const delteNotesReplies = async (payload: any) => {
  try {
      const response = await fetchClient().post(`${BASE_URL}${endPoints.DELETE_NOTES_REPLY}`, payload);
      return response;
  } catch (e) {
      console.log('error', e);
      return e;
  }
};